import * as React from 'react';
import { useState } from 'react';
import axiosApiInstance from "../../../api/axiosClient";
import { Button, notification, Tooltip } from "antd";
import { ModalForm, ProFormText } from '@ant-design/pro-components';
import { FileExcelFilled } from "@ant-design/icons";

type Props = {
    selectedIds: number[];
};

const ExportCreatorsGoogleSheet: React.FC<Props> = ({ selectedIds }) => {
    const [exporting, setExporting] = useState(false);
    const [sheetUrl, setSheetUrl] = useState<string | null>(null);

    const disabled = !selectedIds || selectedIds.length === 0;

    const handleExport = async (values: { name: string }) => {
        try {
            setExporting(true);
            notification.info({ message: 'Creating Google Sheet...' });

            const response = await axiosApiInstance.post(`/api/creators/items/export_google_sheet`, {
                name: values.name,
                creator_ids: selectedIds,
            });

            const url = response?.data?.url;
            if (url) {
                setSheetUrl(url);
                window.open(url, '_blank', 'noopener,noreferrer');
            }

            notification.success({ message: 'Google Sheet created successfully' });
            return false; // Don't close modal
        } catch (error) {
            notification.error({ message: 'Failed to create Google Sheet' });
            return false;
        } finally {
            setExporting(false);
        }
    };

    return (
        <ModalForm
            width={400}
            title={"Export selected creators to Google Sheet"}
            trigger={
                <Tooltip title={disabled ? 'Select at least one creator' : 'Export selected to Google Sheet'}>
                    <Button type={"text"} icon={<FileExcelFilled />} disabled={disabled} />
                </Tooltip>
            }
            submitter={{ submitButtonProps: { loading: exporting } }}
            autoFocusFirstInput
            modalProps={{
                destroyOnClose: true,
                okText: 'Create',
                cancelText: 'Cancel',
            }}
            onFinish={handleExport}
        >
            <ProFormText
                name="name"
                label="Sheet name"
                placeholder="Enter sheet name"
                rules={[{ required: true, message: 'Please enter a sheet name' }]}
            />
            {sheetUrl && (
                <div style={{ marginTop: 16, padding: 12, background: '#f0f2f5', borderRadius: 4 }}>
                    <a href={sheetUrl} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
                        {sheetUrl}
                    </a>
                </div>
            )}
        </ModalForm>
    );
};

export default ExportCreatorsGoogleSheet;
